module.exports = __webpack_public_path__ + "static/media/portfolio_site_spyder_1-01.5499f01f.png";